var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfusionFounGray({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    fill: "#F0F0F0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1126_20679)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5931 18.4105C21.5931 20.1475 21.6174 23.6215 21.5931 25.0062C21.6052 25.2855 21.5323 25.8261 21.2955 26.1419C20.9554 26.6035 20.1598 26.5366 20.0687 26.5306H13.5156C12.6714 26.5306 11.9911 25.8504 11.9911 25.0062V15.0034C11.9911 14.1592 12.6714 13.479 13.5156 13.479H20.0687C20.9129 13.479 21.5931 14.1592 21.5931 15.0034",
    stroke: "#572580",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1187 20.2024C12.8111 20.1052 13.8678 20.0141 15.1432 20.1477C16.1271 20.2509 16.6312 20.4271 17.5179 20.5911C18.4289 20.755 19.765 20.919 21.4838 20.8158",
    stroke: "#572580",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4124 15.7383H15.1311",
    stroke: "#572580",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4124 17.439H14.3719",
    stroke: "#572580",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0002 22.6982C25.0002 21.5564 25.9416 20.6211 27.0773 20.6211C28.213 20.6211 29.1544 21.5625 29.1544 22.6982V27.4779",
    stroke: "#572580",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.996 22.9837C22.996 20.7548 24.8302 18.9268 27.053 18.9268C29.2758 18.9268 31.11 20.7609 31.11 22.9837L31.1343 27.478",
    stroke: "#572580",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8762 27.6358C17.8762 28.7776 19.0302 29.7129 20.4392 29.7129C21.8482 29.7129 23.0021 28.7716 23.0021 27.6358V23.3359",
    stroke: "#572580",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7748 27.9517C15.7748 30.1806 17.8337 32.0087 20.342 32.0087C22.8503 32.0087 24.9091 30.1745 24.9091 27.9517L25.0063 22.9473",
    stroke: "#572580",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7748 27.994V27.0405",
    stroke: "#572580",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8762 27.6357V27.0405",
    stroke: "#572580",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6262 28.2676H28.7353V30.4358H31.6262V28.2676Z",
    stroke: "#572580",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1495 11.9912H15.2586V13.4792H18.1495V11.9912Z",
    stroke: "#572580",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1126_20679"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.2424,
    height: 20.625,
    fill: "white",
    transform: "translate(11.6875 11.6875)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfusionFounGray);
export default __webpack_public_path__ + "static/media/infusionFounGray.e6e9b7b32ca010e48b59269097ddf843.svg";
export { ForwardRef as ReactComponent };